// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"cce7e2af017f44b0ad4e","655":"995b8b0941421c1476e8"}[chunkId] + ".js";
};